module.exports = __webpack_public_path__ + "static/pptr-732df0c8561b5622a884af310f141b7c.svg";